// extracted by mini-css-extract-plugin
export var button = "Search-module--button--d87a2";
export var field = "Search-module--field--3a083";
export var fieldSmall = "Search-module--field--small--1b0fb";
export var form = "Search-module--form--3b83d";
export var icon = "Search-module--icon--23270";
export var input = "Search-module--input--82b4b";
export var label = "Search-module--label--11baf";